import React from "react";
import "./DashboardSkeleton.css";

const SkeletonText = ({ width, height, style = {} }) => (
  <div className="skeleton-text" style={{ width, height, ...style }}></div>
);

const SkeletonCircle = ({ size, style = {} }) => (
  <div
    className="skeleton-circle"
    style={{ width: size, height: size, ...style }}
  ></div>
);

const SkeletonChart = ({ height = "300px" }) => (
  <div className="skeleton-body" style={{ height }}>
    <div className="skeleton-chart"></div>
  </div>
);

// Individual skeleton components for each card
export const AverageDaysSkeleton = () => (
  <>
    <div className="card-header">AVERAGE DAYS TO CLOSE TICKETS</div>
    <div className="card-body">
      <SkeletonText
        width="80px"
        height="40px"
        style={{ margin: "30px auto" }}
      />
    </div>
  </>
);

export const NewTicketsSkeleton = () => (
  <>
    <div className="card-header">NEW TICKETS</div>
    <div className="row" style={{ height: "20vh" }}>
      <div className="col-md-6 border-right">
        <div className="card-body">
          <SkeletonText
            width="80px"
            height="20px"
            style={{ margin: "30px auto 10px" }}
          />
          <SkeletonText
            width="60px"
            height="40px"
            style={{ margin: "10px auto" }}
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="card-body">
          <SkeletonText
            width="80px"
            height="20px"
            style={{ margin: "30px auto 10px" }}
          />
          <SkeletonText
            width="60px"
            height="40px"
            style={{ margin: "10px auto" }}
          />
        </div>
      </div>
    </div>
  </>
);

export const OpenTicketAllocationSkeleton = () => (
  <>
    <h6 className="mt-1">Open Tickets Allocation</h6>
    <div style={{ width: "50%" }}>
      <SkeletonCircle size="200px" style={{ margin: "20px auto" }} />
    </div>
  </>
);

export const OpenTicketDueDatesSkeleton = () => (
  <>
    <h6 className="mt-2">Open Tickets Due Dates</h6>
    <div style={{ width: "90%", marginBottom: "20px" }}>
      <SkeletonChart height="300px" />
    </div>
  </>
);

export const AllocatedOpenTicketSkeleton = () => (
  <>
    <h6 className="mt-2">Allocated Open Tickets</h6>
    <div style={{ width: "90%", marginBottom: "20px" }}>
      <SkeletonChart height="300px" />
    </div>
  </>
);

export const TicketStatusSkeleton = () => (
  <>
    <h6 className="mt-2">Ticket Status</h6>
    <div style={{ width: "60%", marginBottom: "20px" }}>
      <SkeletonChart height="400px" />
    </div>
  </>
);

// Main dashboard skeleton component (unchanged)
const DashboardSkeleton = ({
  showLastUpdate = true,
  showAverageDays = true,
  showNewTickets = true,
  showAllocation = true,
  showDueDates = true,
  showAllocatedTickets = true,
  showTicketStatus = true,
}) => {
  return (
    <div className="dashboard-skeleton">
      {showLastUpdate && (
        <div className="skeleton-card mb-1 p-2">
          <SkeletonText width="200px" height="20px" />
        </div>
      )}

      <div className="row mb-4">
        <div className="col-md-6">
          {showAverageDays && (
            <div
              className="card mb-2"
              style={{ textAlign: "center", height: "20vh" }}
            >
              <AverageDaysSkeleton />
            </div>
          )}

          {showNewTickets && (
            <div
              className="card"
              style={{ textAlign: "center", height: "20vh" }}
            >
              <NewTicketsSkeleton />
            </div>
          )}
        </div>

        <div className="col-md-6">
          {showAllocation && (
            <div className="card d-flex align-items-center justify-content-center h-100">
              <OpenTicketAllocationSkeleton />
            </div>
          )}
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-6">
          {showDueDates && (
            <div className="card d-flex align-items-center justify-content-center">
              <OpenTicketDueDatesSkeleton />
            </div>
          )}
        </div>

        <div className="col-md-6">
          {showAllocatedTickets && (
            <div className="card d-flex align-items-center justify-content-center">
              <AllocatedOpenTicketSkeleton />
            </div>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          {showTicketStatus && (
            <div className="card d-flex align-items-center justify-content-center mb-4">
              <TicketStatusSkeleton />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardSkeleton;
